export const getMessageFromError = function (err) {
  const message = err.response && err.response.data && err.response.data.message

  return message || 'Something went wrong'
}
